import { UpdatedByModel } from './updated-by.model';
import { BaseModel, Default } from '@red/data-access';
import { Expose, Transform } from 'class-transformer';
import { ICommSchemeSetup } from '../interfaces/comm-scheme-setup.interface';
import { SplitPartModel } from './split-part.model';
import { CompanyModel } from './company.model';
import { YES_NO_OPTIONS } from '../data/yes-no.data';
import { YesNoOption } from '../types/yes-no.type';
import { EYesNo } from '../enums/yes-no.enum';

export class CommSchemeSetupModel extends BaseModel implements ICommSchemeSetup {
  @Expose()
  id!: number;

  @Expose()
  name!: string;

  @Expose()
  code!: string;

  @Expose()
  companyId!: number;

  @Expose()
  businessUnitId!: number;

  @Expose()
  company!: CompanyModel;

  @Expose()
  createdAt!: string;

  @Expose()
  createdBy!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  updatedBy!: UpdatedByModel;

  @Expose()
  isActive!: boolean;

  @Expose()
  @Transform(({ obj }: { obj: ICommSchemeSetup }) => {
    return YES_NO_OPTIONS[obj.isActive ? EYesNo.Yes : EYesNo.No] ?? null;
  })
  activeInfo!: YesNoOption | null;

  @Expose()
  isDefault!: boolean;

  @Expose()
  @Transform(({ obj }: { obj: ICommSchemeSetup }) => {
    return YES_NO_OPTIONS[obj.isDefault ? EYesNo.Yes : EYesNo.No] ?? null;
  })
  defaultInfo!: YesNoOption | null;

  @Expose()
  startDate!: string;

  @Expose()
  endDate!: string;

  @Expose()
  tiers!: SplitPartModel[];

  @Expose()
  parties!: SplitPartModel[];

  @Expose()
  remarks!: string;
}
